import { useId } from 'react';
import { DATE_INPUT_CLASS } from '../browserStyles';

interface ChipDateFieldProps {
    label: string;
    value: string;
    min?: string;
    max?: string;
    invalid?: boolean;
    autoFocus?: boolean;
    onChange: (value: string) => void;
    onDone: () => void;
}

export function ChipDateField({
    label,
    value,
    min,
    max,
    invalid = false,
    autoFocus = false,
    onChange,
    onDone
}: ChipDateFieldProps) {
    const id = useId();
    return (
        <div className="flex min-w-0 flex-1 flex-col gap-1">
            <label htmlFor={id} className="text-[11px] font-semibold text-gray-500">
                {label}
            </label>
            <input
                id={id}
                type="date"
                value={value}
                min={min}
                max={max}
                aria-invalid={invalid}
                autoFocus={autoFocus}
                onChange={(event) => onChange(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') onDone();
                }}
                className={`${DATE_INPUT_CLASS} ${invalid ? '!border-red-300' : ''}`}
            />
        </div>
    );
}
